import { applySpec, pathOr } from 'ramda'

const UserTokens = applySpec({
  auth: pathOr('', ['authToken']),
  refresh: pathOr('', ['refreshToken']),
})

export default UserTokens
